import { graphql } from '../graphql';

/** Kick off an IFC → LandXML surface export. Returns the synthetic ANALYSIS batch id. */
export const startLandxmlExport = graphql(`
  mutation StartLandxmlExport($input: StartLandxmlExportInput!) {
    startLandxmlExport(input: $input)
  }
`);
